import { useMemo } from 'react';

import { generateTableData } from '@/utils';

import SimpleBar from 'simplebar-react';
// types
import { TableProps } from '.';
import TableHead from './TableHead';
import TableBody from './TableBody';

export type TableCoreProps<
  TableRowData extends Record<string, unknown>
> = TableProps<TableRowData>;

/**
 * @component TableCore
 */
function TableCore<TableRowData extends Record<string, unknown>>({
  columns,
  disableLastBorder,
  data,
}: TableCoreProps<TableRowData>) {
  const tableData = useMemo(() => generateTableData(data), [data]);

  return (
    <div className="w-full">
      <SimpleBar>
        <table className="w-full border-collapse table-auto">
          <TableHead columns={columns} />
          <TableBody
            disableLastBorder={disableLastBorder}
            columns={columns}
            data={tableData}
          />
        </table>
      </SimpleBar>
    </div>
  );
}

export default TableCore;
